module.exports = __webpack_public_path__ + "static/media/mobile-case.4c18edc1.jpg";